import React, { useState } from 'react';
import { Icon } from 'components/ui';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import { hasFeatureFlags } from 'utils/features';
import { getStatusText } from '../../helpers';
import RSVPPopover from './RSVPPopover';

const RSVPStatus = ({
  attendance,
  event,
  showAttendanceDropdown,
  updateAttendance,
  isMultiSession,
}) => {
  const { created_from: createdFrom, rsvp_status: rsvpStatus } = attendance;
  const [popoverOpen, setPopoverOpen] = useState(false);
  const attendanceTaken =
    event.last_session && event.last_session.attendance_taken;

  const removeAttendance = () => {
    const url = hasFeatureFlags(['events_in_development'])
      ? routes.IN_PERSON_TRAINING.UPDATE_EVENT_ATTENDANCES(
          event.id,
          attendance.id,
        )
      : routes.IN_PERSON_TRAINING.SESSION_ATTENDANCE(
          // because we're pushing data returned from SearchResults/index.jsx#addGuestAttendance
          // into the collection of attendances when searching , the newly added objects
          // will have a different shape (session.id) than that of existing ones (session_id)
          attendance.session_id || attendance.session.id,
          attendance.id,
        );
    request.delete(url).then(({ success }) => {
      if (success) updateAttendance();
    });
  };

  const changeAttendanceStatus = newStatus => {
    const url = routes.IN_PERSON_TRAINING.UPDATE_EVENT_ATTENDANCES(
      event.id,
      attendance.id,
    );
    request
      .putJSON(url, {
        status: newStatus,
      })
      .then(({ attendance: updatedAttendance, success }) => {
        if (success) {
          updateAttendance(updatedAttendance);
          setPopoverOpen(false);
        }
      });
  };

  if (createdFrom === 'created_manually' && event.last_session) {
    return null;
  }

  return (
    <>
      <div>{getStatusText(rsvpStatus, true)}</div>
      {showAttendanceDropdown && !attendanceTaken && !isMultiSession && (
        <div className="pos-r">
          <button
            type="button"
            onClick={() => setPopoverOpen(!popoverOpen)}
            className="u-resetBtn AttendanceRowActions"
          >
            <Icon name="chevron-down" />
          </button>
          {popoverOpen && (
            <RSVPPopover
              removeAttendance={removeAttendance}
              changeAttendanceStatus={changeAttendanceStatus}
              status={rsvpStatus}
              hide={() => setPopoverOpen(!popoverOpen)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default RSVPStatus;
